import Vue from 'vue'
import last from 'lodash/last'
/** 直接放在这个目录下的，自动全局注册 */
const modulesFiles = require.context('@/components', true, /\.vue$/)

modulesFiles.keys().forEach((fileName) => {
  const componentName = last(
    fileName
      .replace(/^\.\//, '')
      .replace(/\.\w+$/, '')
      .split('/')
  )
  if (componentName) {
    Vue.component(componentName, modulesFiles(fileName).default)
  } else {
    console.log('未自动注册的组件:', fileName)
  }
})
